import Lng from "language"
//views  
import QuarterReportPage from "views/dashboards/QuarterReport"
import UserManagementPage from "views/dashboards/user/UserManagement"
import ReportRawSuccessPage from "views/dashboards/ReportRawSuccess"
import ReportQuarterPage from "views/dashboards/ReportQuarter"
import AssignLeadTransferPage from "views/dashboards/AssignLeadTransfer"
import LeadExpiredPage from "views/dashboards/LeadExpired"
import Telesurvey from "views/dashboards/TeleSurvey/Survey"
import QCTelesurvey from "views/dashboards/TeleSurvey/Survey"
// import TelesurveyQC from "views/dashboards/TeleSurveyQC/Survey"
// import CustomerPage from "views/dashboards/Customer" 
import LanguagePage from "views/dashboards/Language"
import ImportLeadPage from "views/dashboards/ImportLead"
import ImportUserPage from "views/dashboards/ImportUser"
import ImportListSMSPage from "views/dashboards/ImportListSMS"
import SendMailPage from "views/dashboards/SendMail"
import ImportEmailPage from "views/dashboards/ImportEmail"
import LeadSMSPage from "views/dashboards/LeadSMS"
import ImportQualityDataPage from "views/dashboards/ImportQualityData"
import MailHotAlertNoCheckPage from "views/dashboards/MailHotAlertNoCheck"
import StatusManagementPage from "views/dashboards/setting/CallInTypeManagement"
import SubStatusManagementPage from "views/dashboards/setting/CallInTypeSub1Management"

import UsageProgressionPage from "views/dashboards/Dashboard/UsageProgression"
import NPSNationwidePage from "views/dashboards/Dashboard/NPSNationwide"
import AVGNationwidePage from "views/dashboards/Dashboard/AVGNationwide"
import DealerPage from "views/dashboards/Dashboard/Dealer"
import LogClearDataPage from "views/dashboards/LogClearData"
import TemplateSMSMessagePage from "views/dashboards/TemplateSMSMessage/"

//icons 
import PermPhoneMsgIcon from '@material-ui/icons/PermPhoneMsg';
import SettingsApplicationsIcon from "@material-ui/icons/SettingsApplications"
import AssignmentReturnedIcon from '@material-ui/icons/AssignmentReturned';
import ListAltIcon from '@material-ui/icons/ListAlt';
import PlaylistPlayIcon from '@material-ui/icons/PlaylistPlay';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import CallIcon from '@material-ui/icons/Call';
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import InsertChartIcon from '@material-ui/icons/InsertChart';
import SendIcon from '@material-ui/icons/Send';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';

//forLogin:true จำเป็นต้องล็อกอินแล้ว , forGuest:true ต้องไม่ล็อกอินอยู่, ถ้าไม่ใส่สองตัวนี้คือเข้าได้หมด
//permission:[0,1,2,3], จำเป็นต้องใส่ forLogin:true ใน Route นั้นด้วย , แล้วใส่ Code ของ User Type นั้นเข้าไปใน Array
const rootPath = "/dashboards"
var dashRoutes = [
  // {
  //   forLogin: true,
  //   collapse: true,
  //   permission:[0,1,2,3,4],
  //   path: rootPath + "/questionManagement",
  //   name: "Setting Question",
  //   state: "openQuestionManagement",
  //   icon: BubbleChartIcon,
  //   views: [
  //     {
  //       path: rootPath + "/questionManagement/Series",
  //       name: "Series",
  //       mini: "SSR",
  //       component: SettingSeriesPage
  //     }
  //   ]
  // },
  // {
  //   forLogin: true,
  //   collapse: true,
  //   permission: [0, 1, 2, 3, 4, 7, 8],
  //   path: rootPath + "/emailHotAlert",
  //   name: Lng.ts("menu_hot_alert"),
  //   state: "openEmailHotAlert",
  //   icon: MailOutlineIcon,
  //   views: [
  //     {
  //       path: rootPath + "/emailHotAlert/noCheck/pr/:id",
  //       name: Lng.ts("menu_คำร้องใหม่"),
  //       mini: "1",
  //       component: MailHotAlertNoCheckPage
  //     },
  //     {
  //       path: rootPath + "/emailHotAlert/checked/pr/:id",
  //       name: Lng.ts("menu_อยู่ระหว่างดำเนินการ"),
  //       mini: "2",
  //       component: MailHotAlertNoCheckPage
  //     },
  //     {
  //       path: rootPath + "/emailHotAlert/checkSuccess/pr/:id",
  //       name: Lng.ts("menu_ดำเนินการแล้วเสร็จ"),
  //       mini: "3",
  //       component: MailHotAlertNoCheckPage
  //     },
  //   ]
  // },
  // {
  //   forLogin: true,
  //   collapse: true,
  //   permission: [0, 1],
  //   path: rootPath + "/SMS",
  //   name: Lng.ts("menu_sms"),
  //   state: "openSMS",
  //   icon: PermPhoneMsgIcon,
  //   views: [
  //     {
  //       path: rootPath + "/SMS/Sent",
  //       name: Lng.ts("menu_sms_sent"),
  //       mini: "1",
  //       component: LeadSMSPage
  //     }
  //   ]
  // },
  {
    forLogin: true,
    // collapse: true,
    // permission: [0, 1],
    path: rootPath + "/SMSManagement",
    name: Lng.ts("menu_sms_management"),
    state: "openSMSManagement",
    icon: AssignmentReturnedIcon,
    component: ImportListSMSPage
  },
  {
    forLogin: true,
    // collapse: true,
    // permission: [0, 1],
    path: rootPath + "/SendSMS",
    name: Lng.ts("menu_send_sms"),
    state: "openSendSMS",
    icon: SendIcon,
    component: SendMailPage
  },
  {
    forLogin: true,
    // collapse: true,
    // permission: [0, 1],
    path: rootPath + "/TemplateSMSMessage",
    name: Lng.ts("menu_template_sms"),
    state: "openTemplateSMSMessage",
    icon: LibraryBooksIcon,
    component: TemplateSMSMessagePage
  },
  // {
  //   forLogin: true,
  //   // collapse: true,
  //   permission: [0, 1],
  //   path: rootPath + "/import",
  //   name: Lng.ts("menu_imports"),
  //   state: "openImport",
  //   icon: AssignmentReturnedIcon,
  //   component: ImportUserPage
  // views: [
  //   {
  //     path: rootPath + "/import/UserManagement",
  //     name: Lng.ts("menu_นำเข้า Users"),
  //     mini: "1",
  //     component: ImportUserPage
  //   },
  // {
  //   path: rootPath + "/import/EmailManagement",
  //   name: Lng.ts("menu_นำเข้า Email Hot Alert"),
  //   mini: "2",
  //   component: ImportEmailPage
  // },
  // {
  //   path: rootPath + "/import/LeadManagement",
  //   name: Lng.ts("menu_นำเข้า Lead"),
  //   mini: "3",
  //   component: ImportLeadPage
  // },
  // {
  //   path: rootPath + "/import/QualityData",
  //   name: Lng.ts("menu_นำเข้า Quality Data"),
  //   mini: "4",
  //   component: ImportQualityDataPage
  // },
  // ]
  // },
  // {
  //   forLogin: true,
  //   collapse: true,
  //   permission: [0, 1, 5],
  //   path: rootPath + "/assignLead",
  //   name: Lng.ts("menu_Assign Lead"),
  //   state: "openAssignLead",
  //   icon: PlaylistPlayIcon,
  //   views: [
  //     {
  //       path: rootPath + "/assignLead/leadExpired",
  //       name: Lng.ts("menu_Lead Expired"),
  //       mini: "1",
  //       component: LeadExpiredPage
  //     },
  //     {
  //       path: rootPath + "/assignLead/transfer",
  //       name: Lng.ts("menu_Transfer"),
  //       mini: "2",
  //       component: AssignLeadTransferPage
  //     },
  //   ]
  // },
  // {
  //   forLogin: true,
  //   collapse: true,
  //   permission: [0, 1, 5, 6],
  //   path: rootPath + "/telesurvey",
  //   name: Lng.ts("menu_Tele Survey"),
  //   state: "openTeleSurvey",
  //   icon: CallIcon,
  //   views: [
  //     {
  //       path: rootPath + "/telesurvey/survey",
  //       name: Lng.ts("menu_Survey"),
  //       mini: "1",
  //       component: Telesurvey
  //     },
  //     {
  //       path: rootPath + "/telesurvey/:successCase",
  //       name: Lng.ts("menu_Success Case"),
  //       mini: "2",
  //       component: Telesurvey
  //     },
  //   ]
  // },
  // {
  //   forLogin: true,
  //   collapse: true,
  //   permission: [0, 1, 9],
  //   path: rootPath + "/QCTelesurvey",
  //   name: Lng.ts("menu_Tele Survey QC"),
  //   state: "openQCTeleSurvey",
  //   icon: VerifiedUserIcon,
  //   views: [
  //     {
  //       path: rootPath + "/QCTelesurvey/qcCheck/pr/:check",
  //       name: Lng.ts("menu_QC Check"),
  //       mini: "1",
  //       component: QCTelesurvey
  //     },
  //     {
  //       path: rootPath + "/QCTelesurvey/qcPass/pr/:pass",
  //       name: Lng.ts("menu_QC Pass"),
  //       mini: "2",
  //       component: QCTelesurvey
  //     },
  //   ]
  // },
  {
    forLogin: true,
    permission: [0, 1, 2, 3, 4],
    path: rootPath + "/report",
    name: Lng.ts("menu_Report"),
    state: "openReport",
    icon: ListAltIcon,
    component: ReportRawSuccessPage
  },
  {
    forLogin: true,
    permission: [0, 1, 2],
    path: rootPath + "/logClearData",
    name: Lng.ts("menu_logClearData"),
    state: "openLogClearData",
    icon: DeleteSweepIcon,
    component: LogClearDataPage
  },
  // {
  //   forLogin: true,
  //   permission: [0, 1, 2],
  //   path: rootPath + "/TopUpCredit",
  //   name: Lng.ts("menu_TopUpCredit"),
  //   state: "openTopUpCredit",
  //   icon: AddShoppingCartIcon,
  //   component: TopUpCreditPage
  // },
  //   views: [
  //     {
  //       path: rootPath + "/report/rawSuccess",
  //       name: Lng.ts("menu_Raw Data Report"),
  //       mini: "1",
  //       component: ReportRawSuccessPage
  //     },
  //     {
  //       path: rootPath + "/report/quarter",
  //       name: Lng.ts("menu_Quarter Report"),
  //       mini: "2",
  //       component: ReportQuarterPage
  //     },
  //   ]
  // },
  // {
  //   forLogin: true,
  //   collapse: false,
  //   permission: [0, 1,
  //     // 3, 4
  //   ],
  //   path: rootPath + "/DealerDashboard",
  //   name: Lng.ts("menu_Dashboard Dealer"),
  //   state: "openDashboardDealer",
  //   icon: InsertChartIcon,
  //   component: DealerPage
  // },
  // {
  //   forLogin: true,
  //   collapse: true,
  //   permission: [0, 1, 2
  //     //  , 3, 4, 5, 7, 8
  //   ],
  //   path: rootPath + "/Dashboard",
  //   name: Lng.ts("menu_Dashboard"),
  //   state: "openDashboard",
  //   icon: InsertChartIcon,
  //   views: [
  //     {
  //       path: rootPath + "/Dashboard/usageProgression",
  //       name: Lng.ts("menu_Usage Progression"),
  //       mini: "DHB1",
  //       component: UsageProgressionPage
  //     },
  //     {
  //       path: rootPath + "/Dashboard/NPSNationwide",
  //       name: Lng.ts("menu_NPS Nationwide"),
  //       mini: "DHB2",
  //       component: NPSNationwidePage
  //     },
  //     {
  //       path: rootPath + "/Dashboard/AVGNationwide",
  //       name: Lng.ts("menu_AVG Nationwide"),
  //       mini: "DHB3",
  //       component: AVGNationwidePage
  //     },
  //   ]
  // },
  {
    forLogin: true,
    collapse: true,
    permission: [0, 1],
    path: rootPath + "/setting",
    name: Lng.ts("menu_Setting"),
    state: "openSetting",
    icon: SettingsApplicationsIcon,
    views: [
      // {
      //   path: rootPath + "/setting/StatusManagement",
      //   name: Lng.ts("menu_Status Management"),
      //   mini: "1",
      //   component: StatusManagementPage
      // },
      // {
      //   path: rootPath + "/setting/SubStatusManagement",
      //   name: Lng.ts("menu_Substatus Management"),
      //   mini: "2",
      //   component: SubStatusManagementPage
      // },
      {
        path: rootPath + "/setting/UserManagement",
        name: Lng.ts("menu_User Management"),
        mini: "3",
        component: UserManagementPage
      },
      {
        path: rootPath + "/setting/language",
        name: Lng.ts("menu_Language Management"),
        mini: "4",
        component: LanguagePage
      },
      // {
      //   path: rootPath + "/setting/QuarterReport",
      //   name: Lng.ts("menu_Quarter Report"),
      //   mini: "5",
      //   component: QuarterReportPage
      // },
    ]
  },

  {
    //สำหรับ path ไม่ตรงเลยให้ย้ายไปหน้า page404
    redirect: true,
    path: rootPath,
    pathTo: "/dashboards/user/management"
    // pathTo: "/page404"
  }
]
export default dashRoutes
